import { ref, computed } from '@vue/composition-api';

export default function useActionLoading (location, experiences, stations) {
  const saving = ref(false);

  const isLoading = computed(() => {
    return !location.value || !experiences.value || !stations.value;
  });

  return {
    saving,
    isLoading,
  };
}
